/*
 *
 * Footer
 *
 * @version 1.0.0
 * @author Marco Civello
 * @since 25-Nov-2024
 */

import React from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import PortalFooter from '@nexidigital/portalfooter'
import { getBankFromContext, getObjSkinMapping, checkSkinMapping } from 'Utility/bankMethods'
import { messages } from './languageModule'
import './Footer.scss'

const Footer = () => {
  const intl = useIntl()
  const bank = getBankFromContext()

  const DEFAULT_LINKS = [
    {
      id: 'privacy',
      label: intl.formatMessage(messages.privacy),
      path: getObjSkinMapping(bank, 'footer', 'linkPrivacy'),
      isExternal: true,
      newTab: true,
      action: false,
      isUnderline: 'always'
    },
    {
      id: 'cookies',
      label: intl.formatMessage(messages.cookies),
      path: getObjSkinMapping(bank, 'footer', 'linkCookies'),
      isExternal: true,
      newTab: true,
      action: false,
      isUnderline: 'always'
    }
  ]

  return <PortalFooter links={DEFAULT_LINKS} bank={checkSkinMapping(bank)} logoType='footerLogo' />
}

Footer.propTypes = {
  // Add here some propTypes
  // and set a minimal description i.e.
  /** Description of prop "baz". */
  links: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
      path: PropTypes.string.isRequired,
      isExternal: PropTypes.bool.isRequired
    })
  ).isRequired
}

Footer.defaultProps = {
  // Add here some default propTypes values
  links: []
}

export default Footer
